import { useMousePosition } from '../../hooks/useMousePosition';
import { useState, useEffect } from 'react';

export default function CustomCursor() {
  const { x, y } = useMousePosition();
  const [isPointer, setIsPointer] = useState(false);

  useEffect(() => {
    const handleMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (
        target.tagName === 'A' ||
        target.tagName === 'BUTTON' ||
        target.closest('a') ||
        target.closest('button') ||
        target.style.cursor === 'pointer'
      ) {
        setIsPointer(true);
      } else {
        setIsPointer(false);
      }
    };

    document.addEventListener('mouseover', handleMouseOver);
    return () => document.removeEventListener('mouseover', handleMouseOver);
  }, []);

  return (
    <>
      <div
        className="fixed w-2 h-2 bg-zinc-900 rounded-full pointer-events-none z-[9999] mix-blend-difference hidden lg:block"
        style={{
          left: `${x}px`,
          top: `${y}px`,
          transform: 'translate(-50%, -50%)',
          transition: 'width 0.2s, height 0.2s',
          width: isPointer ? '40px' : '8px',
          height: isPointer ? '40px' : '8px',
        }}
      />
      <div
        className="fixed w-8 h-8 border border-zinc-900 rounded-full pointer-events-none z-[9998] mix-blend-difference hidden lg:block"
        style={{
          left: `${x}px`,
          top: `${y}px`,
          transform: 'translate(-50%, -50%)',
          transition: 'transform 0.15s ease-out',
          opacity: isPointer ? 0 : 1,
        }}
      />
    </>
  );
}
